import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useLazyCheckFanPageHandleQuery } from "../../store/api/mlbApi";

const PublishHandleDialog = ({
  open,
  suggestedHandle,
  onClose,
  onPublish,
  publishing = false,
}) => {
  const [handle, setHandle] = useState(suggestedHandle || "");
  const [checkHandle, { data, isFetching }] = useLazyCheckFanPageHandleQuery();

  useEffect(() => {
    if (open) setHandle(suggestedHandle || "");
  }, [open, suggestedHandle]);

  useEffect(() => {
    const next = handle.trim().toLowerCase();
    if (!open || next.length < 3) return undefined;
    const timer = setTimeout(() => {
      checkHandle(next);
    }, 300);
    return () => clearTimeout(timer);
  }, [handle, open, checkHandle]);

  const availability = data;
  const blocked = Boolean(availability && availability.available === false);
  const canPublish =
    handle.trim().length >= 3 && !blocked && !isFetching && !publishing;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Choose your public handle</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          This becomes your share URL. You can change it now; after you publish
          it’s locked.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="Handle"
          value={handle}
          onChange={(event) => setHandle(event.target.value)}
          helperText={
            blocked
              ? availability.error
              : `stats.fan/u/${handle.trim().toLowerCase() || "yourhandle"}`
          }
          error={blocked}
          inputProps={{ maxLength: 20, spellCheck: false }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!canPublish}
          onClick={() => onPublish(handle.trim().toLowerCase())}
        >
          {publishing ? "Publishing…" : "Publish page"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PublishHandleDialog;
